import React, {useCallback, useEffect} from 'react';
import {View} from 'react-native';
import {connect} from 'react-redux';
import {ApiResponse} from '../../../data/types/interface/api';
import mapDispatchToProps from '../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../services/redux/mapStateToProps';
import {ListCategorie} from '../../components/List/ListCategorie';
import { HeaderScreen } from '../../components/Header/HeaderScreen';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function DemarcheCategorieScreen(props: any) {
  const {data, isCatalogue, libelle, titleParent} = props.route.params;
  const {getCatalogue, getDemarche} = props;
  const [isLoading, setLoading] = React.useState(true);
  const [dataList, setData] = React.useState([]);
  const [refreshing, setRefreshing] = React.useState(false);

  useEffect(() => {
    if (isCatalogue) {
      getListCatalogue();
    } else {
      getListDemarche();
    }
  }, []);

  const getListCatalogue = useCallback(() => {
    getCatalogue(
      {},
      (res: ApiResponse) => {
        if (res && res.data) {
          setData(res.data);
          setLoading(false);
        }
      },
      `/categorie/${data}`,
    );
  }, []);

  const getListDemarche = useCallback(() => {
    getDemarche(
      {},
      (res: ApiResponse) => {
        if (res && res.data) {
          setData(res.data);
          setLoading(false);
        }
      },
      `/categorie/${data}`,
    );
  }, []);

  const onRefresh = React.useCallback(() => {
    setRefreshing(true);
    if (isCatalogue) {
      getListCatalogue();
    } else {
      getListDemarche();
    }
    setRefreshing(false);
  }, []);

  return (
    <View style={{flex: 1}}>
      <HeaderScreen title={titleParent} type="retour" noBreadcrumb={false} />
      <ListCategorie
        titleParent={titleParent}
        datas={dataList}
        isCatalogue={isCatalogue}
        libelle={libelle}
        isLoading={isLoading}
        refreshing={refreshing}
        refreshList={onRefresh}
      />
    </View>
  );
}

export const DemarcheCategorie = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DemarcheCategorieScreen);
